import React from 'react';
import { FileText, Zap, MessageCircle, ShieldCheck, Lock, CreditCard, Globe } from 'lucide-react';
import { Button } from './Shared';
export const Hero = () => {
  return <section className="relative px-4 overflow-hidden py-10 md:py-16 pt-[32px] pb-[32px]" data-id="element-151">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_50%_-20%,rgba(236,72,153,0.15),transparent_70%)] pointer-events-none" data-id="element-152"></div>
      <div className="absolute top-20 left-10 w-2 h-2 bg-pink-500 rounded-full opacity-40 blur-[1px]" data-id="element-153"></div>
      <div className="absolute top-40 right-20 w-3 h-3 bg-pink-500 rounded-full opacity-20 blur-[2px]" data-id="element-154"></div>

      <div className="max-w-6xl mx-auto text-center relative z-10" data-id="element-155">
        <div className="inline-flex items-center space-x-2 text-pink-400 font-sans font-bold tracking-[0.15em] uppercase text-[9px] md:text-xs mb-4 bg-white/5 px-3 py-1 rounded-full border border-white/10 backdrop-blur-sm" data-id="element-156">
          <Globe className="w-3 h-3" data-id="element-157" />
          <span data-id="element-158">MUNDO PRÁCTICO™</span>
        </div>

        <h1 className="md:text-4xl lg:text-5xl text-white mb-6 tracking-tight max-w-4xl mx-auto px-2 font-[800] font-[Montserrat,_sans-serif] text-[22px]" data-id="element-159">
          Vendés por WhatsApp, cobrás por transferencia y entregás pedidos…{' '}
          <span className="text-pink-400" data-id="element-160">
            pero no sabés dónde queda la plata.
          </span>
        </h1>

        <div className="relative max-w-2xl mx-auto px-4 mb-6" data-id="element-161">
          <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(236,72,153,0.15)_0%,transparent_60%)] rounded-full blur-2xl" data-id="element-162"></div>
          <img src="https://cdn.magicpatterns.com/uploads/vBukzSF3SWtGti7UtzBFwo/Mockup-Caja-Ordenada_(1).webp" alt="Método Caja Ordenada" className="relative z-10 w-full max-w-[280px] md:max-w-[500px] mx-auto h-auto drop-shadow-[0_15px_30px_rgba(0,0,0,0.4)]" width={500} height={500} loading="eager" fetchPriority="high" data-id="element-163" />
        </div>

        <div className="max-w-xl mx-auto space-y-3 mb-6 px-2" data-id="element-164">
          <p className="text-white font-bold md:text-base tracking-wide uppercase text-[11px] leading-snug" data-id="element-165">
            El sistema práctico para controlar pedidos, cobros, señas, stock y
            entregas con plantillas simples listas para usar.
          </p>
          <p className="text-gray-400 md:text-xs font-sans max-w-md mx-auto text-[10px] uppercase tracking-widest font-semibold opacity-80" data-id="element-166">
            Pedidos registrados • Cobros verificados • Señas controladas • Stock
            al día • Entregas sin errores • Caja semanal clara
          </p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-2 md:gap-6 text-white/90 mb-8 max-w-md md:max-w-none mx-auto" data-id="element-167">
          {[{
          icon: FileText,
          text: '100% PDF'
        }, {
          icon: Zap,
          text: 'Acceso en 5 min'
        }, {
          icon: MessageCircle,
          text: 'Para ventas por WhatsApp/Instagram'
        }, {
          icon: ShieldCheck,
          text: 'Garantía 7 días'
        }].map((item, i) => <div key={i} className="flex items-center space-x-1.5 bg-white/5 px-2.5 py-1 rounded-md border border-white/10 backdrop-blur-sm" data-id="element-168">
              <item.icon className="w-3 h-3 md:w-4 md:h-4 text-pink-400" data-id="element-169" />
              <span className="md:text-sm font-semibold tracking-wide whitespace-nowrap text-[9px]" data-id="element-170">
                {item.text}
              </span>
            </div>)}
        </div>

        <Button href="#plan-premium" className="w-full md:w-auto text-sm md:text-xl px-6 md:px-12 py-4 md:py-6" data-id="element-171">
          🟠 → QUIERO MI MÉTODO CAJA ORDENADA AHORA
        </Button>

        <div className="flex items-center justify-center space-x-4 text-[10px] md:text-sm text-gray-400 mt-6 font-medium" data-id="element-172">
          <span className="flex items-center" data-id="element-173">
            <Lock className="w-4 h-4 mr-2 text-green-400" data-id="element-174" /> Pago seguro
          </span>
          <span className="w-px h-4 bg-white/10" data-id="element-175"></span>
          <span className="flex items-center" data-id="element-176">
            <CreditCard className="w-4 h-4 mr-2 text-blue-400" data-id="element-177" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
};